import {
  Container, Typography, Box, Tab, Tabs, Grid, Card, CardContent, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material'
import { ChevronRight } from 'lucide-react';
import React, { useEffect } from 'react'
import { keyframes } from '@mui/system';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { styled } from '@mui/material/styles';

import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HomeIcon from '@mui/icons-material/Home';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import WorkIcon from '@mui/icons-material/Work';
import HouseIcon from '@mui/icons-material/House';
import GoldIcon from '@mui/icons-material/Palette';
import TravelIcon from '@mui/icons-material/Flight';
import TimerIcon from '@mui/icons-material/Timer';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};
const LoanSchemesBackground = styled(Box)({
  background: 'linear-gradient(to right, #1976d2, #512da8)',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  padding: '2rem 0',
  color: 'white',
});

const LoanSchemesPaper = styled(Paper)(({ theme }) => ({
  borderRadius: '15px',
  padding: theme.spacing(4),
  background: 'rgba(255, 255, 255, 0.9)',
  boxShadow: theme.shadows[10],
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.02)',
  },
}));




function JanaNidhiDetails() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);
  const [value, setValue] = React.useState(0);
  const images = [
    "/savings-1.jpg",
    "/savings-2.png",
    "/savings-3.png",
    "/savings-4.png "
  ];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };
  // Data for special table (first table)
  const tableData = [
    {
      title: "Current Interest Rate of Deposits",
      header: ["Period", "Regular", "Senior Citizen"],
      data: [
        { Period: "16 to 45 Days", Regular: "4.00%", SeniorCitizen: "4.25%" },
        { Period: "46 to 90 Days", Regular: "5.30%", SeniorCitizen: "5.55%" },
        { Period: "91 to 180 Days", Regular: "5.50%", SeniorCitizen: "5.75%" },
        { Period: "181 to 270 Days", Regular: "5.50%", SeniorCitizen: "5.75%" },
        { Period: "271 to 365 Days", Regular: "6.70%", SeniorCitizen: "6.95%" },
        { Period: "13 Months to 23 Months", Regular: "8.20%", SeniorCitizen: "8.45%" },
        { Period: "24 Months to 24 Months", Regular: "8.30%", SeniorCitizen: "8.55%" },
        { Period: "25 Months to 60 Months", Regular: "8.50%", SeniorCitizen: "8.75%" },
        { Period: "37 Months to 60 Months", Regular: "8.50%", SeniorCitizen: "8.75%" }
      ],
    },
    {
      title: "Recurring Deposit",
      header: ["Tenure (Months)", "Installment Amount / Month", "Maturity Amount (Regular)"],
      data: [
        { "Tenure (Months)": "12", "Installment Amount / Month": "8050", "Maturity Amount (Regular)": "100160" },
        { "Tenure (Months)": "24", "Installment Amount / Month": "3850", "Maturity Amount (Regular)": "100771" },
        { "Tenure (Months)": "36", "Installment Amount / Month": "2450", "Maturity Amount (Regular)": "100681" },
        { "Tenure (Months)": "48", "Installment Amount / Month": "1750", "Maturity Amount (Regular)": "100211" },
        { "Tenure (Months)": "60", "Installment Amount / Month": "1340", "Maturity Amount (Regular)": "100301" }
      ]
    },
    {
      title: "Monthly Interest Scheme 1,00,000/-",
      header: ["Tenure (Months)", "Int Rate", "Regular (Monthly Int)", "Senior Citizen"],
      data: [
        { "Tenure (Months)": "12", "Int Rate": "6.70%", "Regular (Monthly Int)": "558", "Senior Citizen": "579" },
        { "Tenure (Months)": "24", "Int Rate": "8.30%", "Regular (Monthly Int)": "691", "Senior Citizen": "712" },
        { "Tenure (Months)": "36", "Int Rate": "8.50%", "Regular (Monthly Int)": "708", "Senior Citizen": "729" },
        { "Tenure (Months)": "48", "Int Rate": "8.50%", "Regular (Monthly Int)": "708", "Senior Citizen": "729" },
        { "Tenure (Months)": "60", "Int Rate": "8.50%", "Regular (Monthly Int)": "708", "Senior Citizen": "729" }
      ]
    },
    {
      title: "Cumulative Deposit Amount 1,00,000/-",
      header: ["Tenure (Months)", "Int. Rate", "Regular", "Yield Rate (Regular)", "Senior Citizen", "Yield Rate (Senior Citizen)"],
      data: [
        { "Tenure (Months)": "12", "Int. Rate": "6.70%", "Regular": "106870", "Yield Rate (Regular)": "6.87%", "Senior Citizen": "107133", "Yield Rate (Senior Citizen)": "7.13%" },
        { "Tenure (Months)": "24", "Int. Rate": "8.30%", "Regular": "117856", "Yield Rate (Regular)": "8.93%", "Senior Citizen": "118435", "Yield Rate (Senior Citizen)": "9.22%" },
        { "Tenure (Months)": "36", "Int. Rate": "8.50%", "Regular": "128701", "Yield Rate (Regular)": "9.57%", "Senior Citizen": "129650", "Yield Rate (Senior Citizen)": "9.88%" },
        { "Tenure (Months)": "48", "Int. Rate": "8.50%", "Regular": "139995", "Yield Rate (Regular)": "10.00%", "Senior Citizen": "141372", "Yield Rate (Senior Citizen)": "10.34%" },
        { "Tenure (Months)": "60", "Int. Rate": "8.50%", "Regular": "152279", "Yield Rate (Regular)": "10.46%", "Senior Citizen": "154154", "Yield Rate (Senior Citizen)": "10.83%" }
      ]
    }
  ];
  const SchemeDescription = () => (
    <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
      {/* <Typography variant="h4" component="h2" sx={{ color: 'primary.main', mb: 2 }}>
        Scheme Details
      </Typography> */}
      <Typography variant="h5" align="center" sx={{ mb: 3, color: 'primary.main' }}>
        Information
      </Typography>
      <Typography variant="body1" gutterBottom sx={{
        position: "relative",
        width: '100%',
        height: 'auto',
        textAlign: 'justify',
        fontSize: { xs: '1rem', md: '1.1rem' },
        lineHeight: 1.8,
      }}>
        The <Box component="span" sx={{ fontWeight: 'bold' }}>NYCS Jananidhi Deposit Scheme</Box> offers
        competitive interest rates on fixed deposits for both regular investors and senior citizens.
        The scheme provides flexible deposit periods ranging from
        <Box component="span" sx={{ fontWeight: 'bold' }}> 16 days to 60 months</Box>, with higher
        interest rates for longer durations.
      </Typography>

      <Box sx={{ bgcolor: 'tranparent', p: 3, borderRadius: 2 }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'primary.dark' }}>
          Key Features
        </Typography>
        <List>
          {[
            'Flexible tenure options from 16 days to 60 months',
            'Competitive interest rates with a maximum of 8.75% for senior citizens',
            'Secure and reliable investment for steady returns',
            'Special benefits for senior citizens with additional interest'
          ].map((feature, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );

  const SchemeTable = ({ headers, rows, title }) => (
    <Paper elevation={3} sx={{ p: 2, mt:5  }}>
      <Typography variant="h5" align="center" sx={{ mb: 3, color: 'primary.main' }}>
        {title}
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: 'primary.main' }}>
              {headers.map((header, index) => (
                <TableCell key={index} sx={{ color: 'white', fontWeight: 'bold' }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={{ bgcolor: rowIndex % 2 === 0 ? 'grey.50' : 'white' }}>
                {Object.values(row).map((cell, cellIndex) => (
                  <TableCell key={cellIndex}>{cell}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );

  const loanSchemes = [
    { id: 1, name: 'Small Loan Scheme', icon: <AccountBalanceIcon color="primary" /> },
    { id: 2, name: 'Personal Loan', icon: <AttachMoneyIcon color="primary" /> },
    { id: 3, name: 'Business Loan', icon: <WorkIcon color="primary" /> },
    { id: 4, name: 'Housing Loan', icon: <HomeIcon color="primary" /> },
    { id: 5, name: 'Mortgage Loan', icon: <HouseIcon color="primary" /> },
    { id: 6, name: 'Vehicle Loan', icon: <DirectionsCarIcon color="primary" /> },
    { id: 7, name: 'Gold Loan', icon: <GoldIcon color="primary" /> },
    { id: 8, name: 'Tourism Loan', icon: <TravelIcon color="primary" /> },
    { id: 9, name: 'Term Loan', icon: <TimerIcon color="primary" /> },
    { id: 10, name: 'Loan Against Deposit', icon: <AccountBalanceWalletIcon color="primary" /> }
  ];  


  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography
          variant="h2"
          align="center"
          sx={{
            mb: 6,
            background: 'linear-gradient(to right, #1976d2, #512da8)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold',
            textDecoration: 'underline',
            textUnderlineOffset: '8px'
          }}
        >
          Jana Nidhi Scheme
        </Typography>
      </motion.div>

      <Grid container spacing={3} sx={{ mb: 6 }}>
        {images.map((image, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <Card>
                <Box
                  component="img"
                  src={image}
                  alt={`Savings illustration ${index + 1}`}
                  sx={{
                    width: '100%',
                    height: 240,
                    objectFit: 'cover'
                  }}
                />
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      <motion.div variants={fadeInUp} initial="initial" animate="animate">
        <SchemeDescription />
      </motion.div>
   
      <Container maxWidth="lg"  sx={{marginTop:"20px",mb:"20px"}}>
        <LoanSchemesPaper elevation={6}>
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom 
            align="center" 
            color="primary"
            sx={{ fontWeight: 'bold', marginBottom: '2rem' }}
          >
            Jana Nidhi Loan Schemes
          </Typography>
          <List>
            {loanSchemes.map((scheme) => (
              <ListItem 
                key={scheme.id} 
                divider 
                sx={{ 
                  '&:hover': { 
                    backgroundColor: 'rgba(25, 118, 210, 0.1)',
                    borderRadius: '10px'
                  },
                  transition: 'background-color 0.3s ease'
                }}
              >
                <ListItemIcon>{scheme.icon}</ListItemIcon>
                <ListItemText 
                  primary={scheme.name} 
                  primaryTypographyProps={{ 
                    variant: 'subtitle1',
                    color: 'primary',
                    fontWeight: 'medium'
                  }} 
                />
              </ListItem>
            ))}
          </List>
        </LoanSchemesPaper>
      </Container>
  

      <motion.div
        variants={fadeInUp}
        initial="initial"
        animate="animate"
        transition={{ delay: 0.3 }}
      >
        <SchemeTable
          headers={tableData[0].header}
          rows={tableData[0].data}
          title={tableData[0].title}
        />
        <SchemeTable
          headers={tableData[1].header}
          rows={tableData[1].data}
          title={tableData[1].title}
        />
        <SchemeTable
          headers={tableData[2].header}
          rows={tableData[2].data}
          title={tableData[2].title}
        />
        <SchemeTable
          headers={tableData[3].header}
          rows={tableData[3].data}
          title={tableData[3].title}
        />
      </motion.div>
    </Container>
  );
}

export default JanaNidhiDetails


{/* <Card
elevation={3}
sx={{
  maxWidth: '1000px',
  margin: 'auto',
  mt: 4,
  mb: 4,
  backgroundColor: 'background.paper',
  borderRadius: 2
}}
>
<Box
  sx={{
    backgroundColor: 'primary.main',
    py: 3,
    px: 2,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  }}
>
  <Typography
    variant='h4'
    sx={{
      textAlign: 'center',
      color: 'white',
      fontWeight: 'bold',
      fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }
    }}
  >
    JanaNidhi Deposit Schemes
  </Typography>
</Box>

<CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
  <List sx={{ width: '100%' }}>
    {schemes.map((scheme, index) => (
      <React.Fragment key={scheme.name}>
        <ListItem
          sx={{
            py: 2,
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: 'action.hover',
              transform: 'translateX(8px)'
            }
          }}
        >
          <ListItemIcon>
            <ChevronRight
              size={24}
              className="text-primary"
            />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'medium',
                  fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' }
                }}
              >
                {scheme.name}
              </Typography>
            }
            secondary={
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  mt: 0.5,
                  fontSize: { xs: '0.875rem', sm: '0.9rem', md: '1rem' }
                }}
              >
                {scheme.description}
              </Typography>
            }
          />
        </ListItem>
        {index < schemes.length - 1 && (
          <Divider variant="inset" component="li" />
        )}
      </React.Fragment>
    ))}
  </List>
</CardContent>

<CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
  <Typography variant='h5' mb={5} sx={{ textAlign: "center" }}>
    Rate of Interest for Fixed Deposit Schemes
  </Typography>

  <SchemeTable headers={schemeTableData[1].Headers} rows={schemeTableData[1].data} title={schemeTableData[0].title} />
  <Typography variant="body1"
    mt={5}
    gutterBottom sx={{
      position: "relative",
      width: '100%',
      height: 'auto',
      textAlign: 'justify',
      fontSize: { xs: '1rem', md: '1.1rem' },
      lineHeight: 1.8,
    }}>
    The rates of interest for Fixed Deposit Scheme are applicable to Recurring Deposit Scheme, Reinvestment Scheme, Jananidhi Cash Certificate, Millionaire Deposit Scheme.
    Nomination facility is available for all deposits.
    Loan will be available against deposits up to 75% of amount held as deposit i.e. with a margin of 25%. Rate of Interest for loans against deposits will be 2% above the contracted rate of interest for that Deposit Receipt.
    <br />
    <br />
    For premature deposits rate of interest will be 2% less than the rate of interest applicable to the period for which the deposit has run.
    <br />
    <br />
    Please find appended detailed description of each deposit scheme with the Rate of Interest and expected Maturity Amount:
  </Typography>

</CardContent>
<CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
  <Typography variant='h5' mb={5} sx={{ textAlign: "center" }}>
    Rate of Interest for 
    Recurring Deposti Scheme
  </Typography>
  <SchemeTable headers={schemeTableData[0].Headers} rows={schemeTableData[0].data} title={schemeTableData[0].title} />
</CardContent>
<CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
  <Typography variant='h5' mb={5} sx={{ textAlign: "center" }}>
    Rate of Interest for 
   Jananidhi Re Investment Deposit Scheme
  </Typography>
  <SchemeTable headers={schemeTableData[0].Headers} rows={schemeTableData[0].data} title={schemeTableData[0].title} />
</CardContent>
</Card> */}